import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://maos-backend-3is5.onrender.com/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Attach JWT token to every request if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ime_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ime_token');
      localStorage.removeItem('ime_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

// ─── AUTH ────────────────────────────────────────────────
export const authService = {
  login: (email: string, senha: string) =>
    api.post('/auth/login', { email, senha }),
  perfil: () => api.get('/auth/perfil'),
};

// ─── NOTÍCIAS ────────────────────────────────────────────
export const noticiaService = {
  listar: (params?: any) => api.get('/noticias', { params }),
  buscarPorSlug: (slug: string) => api.get(`/noticias/${slug}`),
  listarAdmin: () => api.get('/noticias/admin'),
  criar: (formData: FormData) =>
    api.post('/noticias', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  atualizar: (id: string, formData: FormData) =>
    api.put(`/noticias/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deletar: (id: string) => api.delete(`/noticias/${id}`),
};

// ─── PROJETOS ────────────────────────────────────────────
export const projetoService = {
  listar: () => api.get('/projetos'),
  buscarPorId: (id: string) => api.get(`/projetos/${id}`),
  criar: (formData: FormData) =>
    api.post('/projetos', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  atualizar: (id: string, formData: FormData) =>
    api.put(`/projetos/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deletar: (id: string) => api.delete(`/projetos/${id}`),
};

// ─── DOCUMENTOS ──────────────────────────────────────────
export const documentoService = {
  listar: (params?: any) => api.get('/documentos', { params }),
  buscarPorId: (id: string) => api.get(`/documentos/${id}`),
  criar: (formData: FormData) =>
    api.post('/documentos', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  atualizar: (id: string, data: any) => api.put(`/documentos/${id}`, data),
  deletar: (id: string) => api.delete(`/documentos/${id}`),
};

// ─── GALERIA ─────────────────────────────────────────────
export const galeriaService = {
  listar: (params?: any) => api.get('/galeria', { params }),
  criar: (formData: FormData) =>
    api.post('/galeria', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deletar: (id: string) => api.delete(`/galeria/${id}`),
};

// ─── MEMBROS ─────────────────────────────────────────────
export const membroService = {
  listar: () => api.get('/membros'),
  criar: (formData: FormData) =>
    api.post('/membros', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  atualizar: (id: string, formData: FormData) =>
    api.put(`/membros/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deletar: (id: string) => api.delete(`/membros/${id}`),
};

// ─── CONTATO ─────────────────────────────────────────────
export const contatoService = {
  enviar: (data: any) => api.post('/contato', data),
  listar: () => api.get('/contato'),
  marcarLido: (id: string) => api.put(`/contato/${id}/lido`),
  deletar: (id: string) => api.delete(`/contato/${id}`),
};

export default api;
